import { Dayjs } from 'dayjs';
import { AdjustmentType, RoundingType, RoundingMethod, Price } from '@weareopenr/types';

export { AdjustmentType, RoundingType, RoundingMethod };
export type IItemPriceResponse = Required<Price>;

export enum PublicationStatus {
  IN_USE = 'IN_USE',
  SCHEDULED = 'SCHEDULED',
  NOT_IN_USE = 'NOT_IN_USE',
  CREATING = 'CREATING',
}

export interface IPriceRuleAdjustment {
  type: AdjustmentType;
  value?: number;
}

export interface IPriceRuleRounding {
  type: RoundingType;
  method?: RoundingMethod;
  value?: number;
}

export interface IPriceRule {
  price_rule_id: string;
  display_order: number;
  adjustment: IPriceRuleAdjustment;
  rounding: IPriceRuleRounding;
  price_band?: IRuleEntity;
  external_system?: IRuleEntity;
}

export interface IRuleEntity {
  name: string;
  id: string;
}

export enum PriceSchemeStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  CREATING = 'CREATING',
  REVIEW = 'REVIEW',
}

export interface IResponsePriceScheme {
  price_scheme_id: string;
  name: string;
  publication_status: PublicationStatus;
  status: PriceSchemeStatus;
  modification_date: Date | string;
  event_id: string | null;
}

export interface IPriceScheme {
  id: string;
  name: string;
  publicationStatus: PublicationStatus;
  modificationDateTime: Dayjs;
  status: PriceSchemeStatus;
  eventId: string | null;
}

export interface IPriceSchemeResponse {
  type: 'price-schemes';
  data: IResponsePriceScheme[];
}
